import React, { useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import {
  LOAD_INDUSRTIES,
  loadIndustries
} from 'src/store/actions/catalogActions';
import { selectIndustriesList } from 'src/store/selectors/catalogSelectors';
import IndustryTable from './IndustriesTable';

const IndustriesList = () => {
  const dispatch = useDispatch();
  const industries = useSelector(selectIndustriesList);
  const loading = useSelector(isLoadingSelector([LOAD_INDUSRTIES.action]));
  const success = useSelector(successSelector([LOAD_INDUSRTIES.action]));

  useEffect(() => {
    dispatch(loadIndustries());
  }, []);

  return (
    <Box mt={3}>
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12}>
          <IndustryTable
            industries={industries}
            loading={loading}
            success={success}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default IndustriesList;
